import { Button, Col, Form, message, Row, Spin, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchExcessStockBundles,
  resetexcessStockData,
  ShiftBundletoWorkOrder,
} from '../../slices/excess-stock';
import { fetchWorkOrderForExcess } from '../../slices/work-order';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import dayjs from 'dayjs';
export default function ShiftBundleToWorkOrder() {
  const dispatch = useDispatch();
  const { Option } = Select;
  const [btnLoading, setBtnLoading] = useState(false);
  const [form] = Form.useForm();

  const [bundle, setBundle] = useState([]);
  const [bundlePage, setBundlePage] = useState(1);
  const [bundlePageSize] = useState(5000);
  const [bundleLoading, setBundleLoading] = useState(false);
  const [bundleHasMore, setBundleHasMore] = useState(true);
  const [bundleTotalCount, setBundleTotalCount] = useState(0);
  const [bundleSearchText, setBundleSearchText] = useState('');
  const [filteredBundles, setFilteredBundles] = useState([]);
  const [bundleDropdownOpen, setBundleDropdownOpen] = useState(false);
  const [workOrderList, setWorkOrderList] = useState([]);
  const [workOrderPage, setWorkOrderPage] = useState(1);
  const [workOrderPageSize] = useState(5000);
  const [workOrderLoading, setWorkOrderLoading] = useState(false);
  const [workOrderHasMore, setWorkOrderHasMore] = useState(true);
  const [workOrderTotalCount, setWorkOrderTotalCount] = useState(0);
  const [workOrderSearchText, setWorkOrderSearchText] = useState('');
  const [filteredWorkOrders, setFilteredWorkOrders] = useState([]);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);

  useEffect(() => {
    resetexcessStockData();
    fetchBundleData(1);
    fetchWorkOrderData(1);
  }, []);

  useEffect(() => {
    if (!bundleSearchText) {
      setFilteredBundles(bundle);
    } else {
      const filtered = bundle.filter(item => {
        const searchStr = bundleSearchText.toLowerCase();
        const bundleText =
          `${item.bundle_inward__bundle_no} ${item.die_profile__die_number} ${item.length} ${item.pieces} ${item.weight} ${item.alloy__name} ${item.alloy__color_code} ${item.temper__name} ${item.temper__code}`.toLowerCase();
        return bundleText.includes(searchStr);
      });
      setFilteredBundles(filtered);
    }
  }, [bundle, bundleSearchText]);

  useEffect(() => {
    if (!workOrderSearchText) {
      setFilteredWorkOrders(workOrderList);
    } else {
      const filtered = workOrderList.filter(wo => {
        const searchStr = workOrderSearchText.toLowerCase();
        const workOrderText =
          `WO-${wo.workorder_no} ${wo.die_profile} ${wo.length} ${wo.packed_weight} ${wo.dispatched_weight} ${wo.net_weight} ${wo.alloy} ${wo.temper}`.toLowerCase();
        return workOrderText.includes(searchStr);
      });
     
      setFilteredWorkOrders(filtered);
    }
  }, [workOrderList, workOrderSearchText]);

  const fetchBundleData = async page => {
    if (
      (!bundleHasMore && page > 1) ||
      (bundleTotalCount > 0 && bundle.length >= bundleTotalCount)
    ) {
      return;
    }

    setBundleLoading(true);
    try {
      const response = await dispatch(
        fetchExcessStockBundles({
          page: page,
          pagesize: bundlePageSize,
        }),
      ).unwrap();

      if (response && response.results) {
        if (response.results.count !== undefined) {
          setBundleTotalCount(response.results.count);
        }

        if (page === 1) {
          setBundle(response.results.data || []);
        } else {
          const existingIds = new Set(bundle.map(item => item.id));
          const newBundles = (response.results.data || []).filter(
            newItem => !existingIds.has(newItem.id),
          );
          setBundle(prevBundles => [...prevBundles, ...newBundles]);
        }

        const hasMore =
          response.results.data &&
          response.results.data.length === bundlePageSize &&
          bundle.length + response.results.data.length <
          (response.results.count || 0);

        setBundleHasMore(hasMore);
        setBundlePage(page);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setBundleLoading(false);
    }
  };

  const fetchWorkOrderData = async page => {
    if (
      (!workOrderHasMore && page > 1) ||
      (workOrderTotalCount > 0 && workOrderList.length >= workOrderTotalCount)
    ) {
      return;
    }

    setWorkOrderLoading(true);
    try {
      const response = await dispatch(
        fetchWorkOrderForExcess({
          page: page,
          pagesize: workOrderPageSize,
        }),
      ).unwrap();

      if (response && response.results) {
        if (response.results.count !== undefined) {
          setWorkOrderTotalCount(response.results.count);
        }

        const newData = response.results.data || [];

        if (page === 1) {
          setWorkOrderList(newData);
        } else {
          const existingIds = new Set(workOrderList.map(item => item.id));
          const newWorkOrders = newData.filter(
            newItem => !existingIds.has(newItem.id),
          );
          setWorkOrderList(prevOrders => [...prevOrders, ...newWorkOrders]);
        }

        const hasMore =
          newData.length === workOrderPageSize &&
          workOrderList.length + newData.length < (response.results.count || 0);

        setWorkOrderHasMore(hasMore);
        setWorkOrderPage(page);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setWorkOrderLoading(false);
    }
  };

  const handleBundlePopupScroll = e => {
    const { target } = e;
    if (
      !bundleLoading &&
      bundleHasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20
    ) {
      fetchBundleData(bundlePage + 1);
    }
  };

  const handleWorkOrderPopupScroll = e => {
    const { target } = e;
    if (
      !workOrderLoading &&
      workOrderHasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20
    ) {
      fetchWorkOrderData(workOrderPage + 1);
    }
  };

  const handleError = error => {
    if (typeof error === 'object' && error !== null) {
      const messages = [];
      for (const key in error) {
        if (Array.isArray(error[key])) {
          messages.push(`${key}: ${error[key].join(', ')}`);
        }
      }

      if (messages.length > 0) {
        message.error(messages.join('; '));
      } else {
        message.error('An unknown error occurred.');
      }
    } else if (typeof error === 'string') {
      message.error(error);
    } else if (error instanceof Error) {
      message.error(error.message);
    } else {
      message.error('An unknown error occurred.');
    }
  };

  const handleBundleSearch = (value) => {
    setBundleSearchText(value);
    // your API call logic...
   
  };

  const handleWorkOrderSearch = value => {
    const searchValue = value || '';
    setWorkOrderSearchText(searchValue);
  };

  const handleBundleDropdownVisibleChange = open => {
    if (!open) {
      setBundleSearchText('');
    }
  };

  const handleWorkOrderDropdownVisibleChange = open => {
    if (!open) {
      setWorkOrderSearchText('');
    }
  };

  const handleBundleChange = (value) => {
    form.setFieldsValue({ bundle_ids: value });
    setBundleDropdownOpen(true); // keep it open after select
    setBundleSearchText(''); // clear search
  };

  const handleWorkOrderChange = value => {
    setWorkOrderSearchText('');
    form.setFieldsValue({ workorder_id: value });
  };

  const handleDropdownVisibleChange = (open) => {
    if (!open) {
      setBundleDropdownOpen(false);
    }
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      const current = form.getFieldValue('bundle_ids') || [];
      if (filteredBundles && filteredBundles.length > 0) {
        const firstId = filteredBundles[0].bundle_inward__id;
        if (!current.includes(firstId)) {
          const newValue = [...current, firstId];
          form.setFieldsValue({ bundle_ids: newValue });
          setBundleDropdownOpen(true); // keep open!
          setBundleSearchText(''); // clear input
          e.preventDefault(); // prevent form submit
        }
      }
    }
  };

  const handleFinish = values => {
    setBtnLoading(true);
    const updatedPayload = {
      workorder_detail_id: selectedWorkOrder?.workroder_detail_id,
      bundle_ids: values?.bundle_ids
    };
    
    dispatch(ShiftBundletoWorkOrder({ values: updatedPayload }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);

        if (result) {
          const {
            success,
            message: resultMessage,
            shifted_bundles = [],
            unshifted_bundles = [],
          } = result;

          if (
            !success &&
            shifted_bundles.length === 0 &&
            unshifted_bundles.length === 0
          ) {
            message.info(resultMessage || 'No bundles were shifted.');
            form.resetFields();
            return;
          }

          if (
            success &&
            shifted_bundles.length > 0 &&
            unshifted_bundles.length === 0
          ) {
            message.success(
              `Successfully shifted ${shifted_bundles.length} bundle(s).`,
            );
            form.resetFields();
            fetchBundleData(1);
            fetchWorkOrderData(1);
            return;
          }

          if (
            success &&
            shifted_bundles.length > 0 &&
            unshifted_bundles.length > 0
          ) {
            const unshiftedDetails = unshifted_bundles
              .map(bundle => `Bundle ${bundle.bundle_no}: ${bundle.reason}`)
              .join('; ');
            message.warning(
              `Partially successful: ${shifted_bundles.length} bundle(s) shifted. Failed to shift ${unshifted_bundles.length} bundle(s): ${unshiftedDetails}`,
            );
            form.resetFields();
            fetchBundleData(1);
            fetchWorkOrderData(1);
            return;
          }

          if (!success && unshifted_bundles.length > 0) {
            const unshiftedDetails = unshifted_bundles
              .map(bundle => `Bundle ${bundle.bundle_no}: ${bundle.reason}`)
              .join('; ');
            message.error(
              `Failed to shift ${unshifted_bundles.length} bundle(s): ${unshiftedDetails}`,
            );
            form.resetFields();
            return;
          }

          message.info(resultMessage || 'Operation completed with no changes.');
          form.resetFields();
        }
      })
      .catch(error => {
        setBtnLoading(false);
        handleError(error);
      });
  };
  return (
    <>
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Row gutter={16}>
          <Col xs={24} xl={12}>
            <Form.Item
              label="Select Bundle"
              name="bundle_ids"
              rules={[
                { required: true, message: 'Please select at least one bundle!' },
              ]}
            >
              <Select
                placeholder="Select Bundle"
                mode="multiple"
                showSearch
                optionFilterProp="children"
                filterOption={false} // using server-side filter
                onSearch={handleBundleSearch}
                onChange={handleBundleChange}
                open={bundleDropdownOpen}
                onDropdownVisibleChange={setBundleDropdownOpen}
                onInputKeyDown={handleInputKeyDown} // handle Enter
                style={{ width: '100%' }}
                onPopupScroll={handleBundlePopupScroll}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    {bundleLoading && (
                      <div style={{ textAlign: 'center', padding: '8px' }}>
                        <Spin size="small" />
                      </div>
                    )}
                  </>
                )}
              >
                {filteredBundles && filteredBundles.length > 0 ? (
                  filteredBundles.map((item) => (
                    <Option key={item.id} value={item.bundle_inward__id}>
                      <div>
                        {item.bundle_inward__bundle_no} | {item.die_profile__die_number} |{' '}
                        {item.length} mm | {item.pieces} pcs | {item.weight} kg
                        <br />
                        {item.alloy__name} {item.alloy__color_code} |{' '}
                        {item.temper__name} {item.temper__code}
                      </div>
                    </Option>
                  ))
                ) : (
                  <Option disabled value="no-bundle">
                    {bundleLoading
                      ? 'Loading bundles...'
                      : bundleSearchText
                        ? 'No bundles found'
                        : 'No bundles available'}
                  </Option>
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} xl={12}>
            <Form.Item
              name="workroder_detail_id"
              label="Select Work Order"
              rules={[{ required: true, message: 'Please Select Work Order!' }]}
            >
              <AutoOpenSelect
                placeholder="Select Work Order"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={false}
                onSearch={handleWorkOrderSearch}
                onChange={(selectedDetailId) => {
                  const selectedWorkOrder = filteredWorkOrders.find(
                    wo => wo.workroder_detail_id === selectedDetailId
                  );
                  console.log("Selected Work Order:", selectedWorkOrder);
                  setSelectedWorkOrder(selectedWorkOrder);
                  handleWorkOrderChange(selectedWorkOrder?.id);
                }}
                onDropdownVisibleChange={handleWorkOrderDropdownVisibleChange}
                style={{ width: '100%' }}
                onPopupScroll={handleWorkOrderPopupScroll}
                dropdownRender={menu => (
                  <>
                    {menu}
                    {workOrderLoading && (
                      <div style={{ textAlign: 'center', padding: '8px' }}>
                        <Spin size="small" />
                      </div>
                    )}
                  </>
                )}
              >
                {filteredWorkOrders && filteredWorkOrders.length > 0 ? (
                  filteredWorkOrders.map(wo => {
                    const displayText = `WO-${wo.workorder_no} | ${wo.die_profile} | ${wo.length} mm | Packed: ${wo.packed_weight || '0.00'
                      } kg | Dispatched: ${wo.dispatched_weight || '0.00'
                      } kg | Net Order: ${wo.net_weight} kg | ${wo.alloy}-${wo.temper}`;

                    return (
                      <Option key={wo.workroder_detail_id} value={wo.workroder_detail_id}>
                        <div title={displayText}>{displayText}</div>
                      </Option>
                    );
                  })
                ) : (
                  <Option disabled value="no-workorder">
                    {workOrderLoading
                      ? 'Loading work orders...'
                      : workOrderSearchText
                        ? 'No work orders found'
                        : 'No WorkOrder Available'}
                  </Option>
                )}
              </AutoOpenSelect>
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={btnLoading}>
                Shift Bundle to WorkOrder
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
